export default {
  auth: {
    login: '/auth/login/',
    forgotPassword: '/usuarios/recuperar-senha/',
  },
  setup: {
    email: '/usuarios/setup/email/',
  },
};
